export default {
  trigger: 'Invitar al dueño del restaurante',
  title: 'Invitar al dueño del restaurante',
  description:
    'Crea una cuenta para el dueño del restaurante. Recibirá un correo con una contraseña temporal para iniciar sesión y terminar de configurar su restaurante.',
  fields: {
    first_name: 'Nombre',
    last_name: 'Apellido',
    email: 'Correo electrónico',
  },
  buttons: {
    invite: 'Enviar invitación',
    cancel: 'Cancelar',
  },
  toasts: {
    invited: '{{email}} ha sido invitado a completar la configuración.',
    failed: 'No se pudo crear la cuenta del dueño. Por favor, inténtalo de nuevo.',
  },
};
